<div class="sidebar-menu-on-small-devices" [style.top.px]="top" [class.sticky]="sticky">
	<mat-tab-group
		mat-align-tabs="center"
		(selectedTabChange)="tabChange($event)"
		(focusChange)="tabChange($event)"
		[selectedIndex]="currentIndex">
		<mat-tab *ngFor="let menu of menuItems" [label]="menu.menuName"></mat-tab>
	</mat-tab-group>
</div>
